import React from 'react';
import { Label } from 'semantic-ui-react';
import { trim } from 'lodash';
import './AvatarLetter.scss';

export default function AvatarLetter({ userName, size, expanded }) {
  const getFirstLetter = (rawWord) => {
    return trim(rawWord).substr(0, 1).toUpperCase();
  };
  return (
    <Label
      style={expanded ? { marginRight: 20 } : {}}
      color="blue"
      className="user-label-initial-icon"
      circular
      size={size}
    >
      {getFirstLetter(userName)}
    </Label>
  );
}
